/** Place a section flush under a sticky chrome bar inside a custom scroll pane. */

export const SCROLL_BELOW_STICKY_GAP_PX = 8;
export const TAX_RETURN_FILTER_BAR_TEST_ID = 'tax-return-filter-bar';

export const scrollDeltaBelowStickyBar = ({
  targetTop,
  scrollParentTop,
  stickyBarHeight,
  gapPx = SCROLL_BELOW_STICKY_GAP_PX,
}: {
  targetTop: number;
  scrollParentTop: number;
  stickyBarHeight: number;
  gapPx?: number;
}): number => targetTop - (scrollParentTop + stickyBarHeight + gapPx);

export const scrollSectionBelowStickyBar = ({
  target,
  scrollParent,
  stickyBar,
  gapPx = SCROLL_BELOW_STICKY_GAP_PX,
  behavior = 'smooth',
}: {
  target: HTMLElement;
  scrollParent: HTMLElement | null | undefined;
  stickyBar: HTMLElement | null | undefined;
  gapPx?: number;
  behavior?: ScrollBehavior;
}): number => {
  if (!scrollParent || typeof scrollParent.scrollBy !== 'function') {
    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior, block: 'start' });
    }
    return 0;
  }
  const delta = scrollDeltaBelowStickyBar({
    targetTop: target.getBoundingClientRect().top,
    scrollParentTop: scrollParent.getBoundingClientRect().top,
    stickyBarHeight: stickyBar ? stickyBar.getBoundingClientRect().height : 0,
    gapPx,
  });
  scrollParent.scrollBy({ top: delta, behavior });
  return delta;
};
